import { call, put, takeEvery, takeLatest } from 'redux-saga/effects';

import { actions } from '../actions/companyModal';
import * as companyAPI from '../api/company';

// Destructure the Company modal actions.
export const {
  companyModalShow,
  companyModalHidden,

  companyModalAddCompany,
  companyModalAddCompanySucceeded,
  companyModalAddCompanyFailed,

  companyModalGetUsers,
  companyModalGetUsersResult,

  companyModalUpdateCompany,
  companyModalUpdateCompanySucceeded,
  companyModalUpdateCompanyFailed,
  companyModalUpdateCompanyAvatarResult,

  companyModalOpenAvatarCropperFileChange,
  companyModalCloseAvatarCropper,

  companyModalGetPresignedUrl,

  companyModalGetPresignedUrlFailed,
  companyModalGetPresignedUrlSucceeded,

  companyModalAvatarUploadFailed,
  companyModalAvatarUploadSucceeded,
} = actions;

export function* companyModalGetPresignedGen(action) {
  try {
    const result = yield call(companyAPI.getPresigned, action.payload);

    yield put({
      type: companyModalGetPresignedUrlSucceeded.toString(),
      presigned: result.data,
      file: action.payload.file,
      companyId: action.payload.companyId,
    });
  } catch (exception: any) {
    console.warn(exception);
    yield put({
      type: companyModalGetPresignedUrlFailed.toString(),
      error: exception.message,
    });
  }
}

export function* companyModalAvatarUploadGen(action) {
  try {
    console.warn('companyModalAvatarUploadGen', action);
    yield call(companyAPI.uploadAvatar, action);
    const payload = {
      companyId: action.companyId,
      patch: {
        updates: {
          avatar_url: action.presigned.download_url,
        },
      },
    };
    yield put({
      type: companyModalAvatarUploadSucceeded.toString(),
      payload: payload,
    });
  } catch (exception: any) {
    console.warn(exception);
    yield put({
      type: companyModalAvatarUploadFailed.toString(),
      error: exception.message,
    });
  }
}

export function* companyModaUpdateCompanyGen(action) {
  let result;
  try {
    result = yield call(companyAPI.updateCompany, action.payload);
    yield call(action.meta.resolve);
    yield put({
      type: companyModalUpdateCompanySucceeded.toString(),
      payload: result,
    });
  } catch (exception: any) {
    console.warn(exception);
    yield call(action.meta.reject, exception);
    result = exception;
    yield put({
      type: companyModalUpdateCompanyFailed.toString(),
      payload: result,
    });
  }
}

export function* companyModaAddCompanyGen(action) {
  let result;
  try {
    result = yield call(companyAPI.createCompany, action.payload);
    yield call(action.meta.resolve);
    yield put({
      type: companyModalAddCompanySucceeded.toString(),
      payload: result,
    });
  } catch (exception: any) {
    console.warn(exception);
    let errors: string[] = [];
    if (
      exception.response !== undefined &&
      exception.response.data !== undefined &&
      exception.response.data.errors !== undefined
    ) {
      errors = exception.response.data.errors;
    }
    errors = errors.length !== 0 ? errors : ['Something went wrong :('];
    yield call(action.meta.reject, errors);
    result = exception;
    yield put({
      type: companyModalAddCompanyFailed.toString(),
      payload: result,
    });
  }
}

// Saga
export const companyModalSagas = [
  takeEvery(companyModalAddCompany.toString(), companyModaAddCompanyGen),
  takeEvery(companyModalUpdateCompany.toString(), companyModaUpdateCompanyGen),
  takeEvery(
    companyModalGetPresignedUrl.toString(),
    companyModalGetPresignedGen,
  ),
  takeEvery(
    companyModalGetPresignedUrlSucceeded.toString(),
    companyModalAvatarUploadGen,
  ),
  takeEvery(
    companyModalAvatarUploadSucceeded.toString() as any,
    simpleApiGen(
      companyAPI.updateCompany,
      companyModalUpdateCompanyAvatarResult,
    ),
  ),
  takeLatest(
    companyModalGetUsers.toString() as any,
    simpleApiGen(companyAPI.readRelatedUsers, companyModalGetUsersResult),
  ),
];

function simpleApiGen(
  apiCall: (action: any) => any,
  resultAction: (result: any) => any,
) {
  return function* (action: { payload: any }) {
    let result;
    try {
      result = yield call(apiCall, action.payload);
    } catch (exception: any) {
      console.warn(exception);
      result = exception;
    }
    yield put(resultAction(result));
  };
}
